import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES } from "@/data";
import { useLang } from "@/lib/lang";

const ease = [0.22, 1, 0.36, 1];
const lineUp = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1, ease, delay: 0.35 + i * 0.12 } }),
};

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const bgScale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);

  return (
    <section className="hero section-line" id="home" ref={ref} data-testid="hero-section">
      <motion.div className="hero-bg" style={{ y: bgY, scale: bgScale }}>
        <img src={IMAGES.heroBg} alt="A katana guard in low light" loading="eager" />
      </motion.div>

      <div className="hero-inner">
        <motion.div
          className="eyebrow"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.15 }}
          data-testid="hero-eyebrow"
        >
          {t.hero.eyebrow}
        </motion.div>

        <h1 data-testid="hero-title">
          {t.hero.titleLines.map((line, i) => (
            <span className="line-mask" key={line}>
              <motion.span style={{ display: "block" }} variants={lineUp} custom={i} initial="hidden" animate="show">
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.7, ease }}
          data-testid="hero-subtitle"
        >
          {t.hero.subtitle}
        </motion.p>

        <motion.div
          className="cta-row"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.85, ease }}
        >
          <button className="btn" data-testid="hero-book-btn" onClick={() => scrollTo("#services")}>
            {t.hero.book}
          </button>
          <button className="btn-outline" data-testid="hero-framework-btn" onClick={() => scrollTo("#framework")}>
            {t.hero.framework}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
